'use client';

export function TextFilter({
  label,
  value,
  placeholder = '',
  onChange,
}) {
  return (
    <div>
      <label className="block text-xs font-medium text-gray-700">
        {label}
      </label>
      <input
        type="text"
        value={value}
        placeholder={placeholder}
        onChange={(e) => onChange(e.target.value)}
        className="mt-1 block w-full rounded-md border-gray-300 text-xs shadow-sm
                   focus:border-primary focus:ring focus:ring-primary-300"
      />
    </div>
  );
}